import { Form, Input } from 'antd'
import React, { forwardRef, useState } from 'react'
import _ from 'lodash'
import BaseModal from './BaseModal'
import { useForm } from 'antd/lib/form/Form'
import { useAutoFocus } from 'hooks/useFocusHelpers'

function DefaultNoteForm({form, noteLength, isNoteRequired, defaultValue="", placeholder=""}){
    return (
        <Form
            layout="vertical"
            form={form}
            initialValues={{ note: defaultValue }}
        >
            <Form.Item label="Note"
                rules={[{
                    required: isNoteRequired,
                    message: "A note is required",
                    whitespace: isNoteRequired
                },{
                    max:noteLength, message:`Maximum length is ${noteLength} characters`
                }]}
                name="note"
            >
                <Input.TextArea autoFocus placeholder = {placeholder}/>
            </Form.Item>
        </Form>
    )
}

export default forwardRef(function ConfirmPopup({type = "delete", isNoteRequired=true, afterClose, promptMessage, onOk = _.noop, noteLength = 500, NoteForm = DefaultNoteForm, ...restProps}, ref) {
    const [enable, setEnable] = useState(restProps.confirmText ? false : true);
    const [loading, setLoading] = useState(false);
    const confirmInputFieldRef = useAutoFocus();
    const _onOk = async () => {
        if(restProps.note){
          await form.validateFields();    
        }
        try {
            // To block UI until API responded
            setLoading(true);
            setEnable(false);
            await onOk(form.getFieldValue("note"), restProps.data);
        } catch (e) { 
            setLoading(false);
            setEnable(true);
            throw e;
        }
    }

    const baseModalProps = {
        ...restProps.modalProps,
        title: !_.isUndefined(restProps.title) ? restProps.title : "Are you sure?",
        onOk: _onOk,
        cancelBtnText: restProps.cancelBtnText,
        okText: restProps.okText || _.capitalize(type),
        okButtonProps: { type: "primary", danger: !_.isEmpty(type), disabled: !enable },
        className: type + "-popup",
        confirmLoading: loading
    }

    const onConfirmTextChange = (e) => {
        const matched = e.target.value === restProps.confirmText;
        // below conditions are to prevent unnecessary state updates and render
        if(matched && !enable){
            setEnable(true);
        }
        if(!matched && enable){
            setEnable(false);
        }
    }

    const onPaste = (e) =>{
        e.preventDefault()
        return false;
    }

    const onCopy =  (e) =>{
        e.preventDefault()
        return false;
    }

    const [form] = useForm();

    return (
        <BaseModal
            modalProps={baseModalProps}
            afterClose={afterClose}
            ref={ref}
        >
            {
                promptMessage
                ?
                <p>{promptMessage}</p>
                :
                null
            }
            {
                restProps.confirmText
                ?
                <>
                    If you are sure, please type <span className="text-bold">{restProps.confirmText}</span> in this box:
                    <br />
                    <Form>
                        <Form.Item>
                            <Input ref={confirmInputFieldRef} placeholder={restProps.confirmText} className="m-t-xs" style={{width: 200}} onPaste={onPaste} onCopy={onCopy} onChange={onConfirmTextChange} />
                        </Form.Item>
                    </Form>
                </>
                :
                null
            }
            {
                restProps.note
                ?
                <NoteForm form={form} noteLength={noteLength} isNoteRequired={isNoteRequired} defaultValue={restProps.defaultValue} placeholder = {restProps.placeholder} />
                :
                null
            }
        </BaseModal>
    )
})
